import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ImageOverlay from './ImageOverlay';
import SecurityMeasures from './SecurityMeasures';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>

    <App />
    {/* <ImageOverlay /> */}
    {/* <SecurityMeasures /> */}
  </React.StrictMode>
);


